// src/pages/pricing.js
import React, { useState } from "react";

const WORKER_URL = "https://reflex-backend.alfaoir1.workers.dev";

const PAYMENT_LINKS = {
  "test-pilot":    "https://links.equiptbiz.com/payment-link/6a3cf4869b12592b368246f5",
  "full-system":   "https://links.equiptbiz.com/payment-link/6a3cf45f9b12592b368246f3",
  "growth-engine": "https://links.equiptbiz.com/payment-link/6a3cf408390a6e280643a8de",
};

const packages = [
  {
    id: "test-pilot",
    badge: "START HERE",
    name: "Test Pilot LaunchPad™",
    price: "$47",
    priceNote: "one-time",
    days: "7 Days",
    highlight: false,
    tag: null,
    tagline: "Try it out and see if it works in your area.",
    footer: "No long contracts",
    features: [
      "We find & contact local businesses for you",
      "Ready-to-go list of nearby companies",
      "We book the meetings — you just show up",
      "Up to 5 real booked appointments",
      "Offices, realtors, builders & managers",
      "We run everything, hands free for you",
    ],
    ctaLabel: "Start Getting Leads",
  },
  {
    id: "full-system",
    badge: "BEST VALUE",
    name: "Full System Dominator™",
    price: "$450",
    originalPrice: "$300",
    priceNote: "one-time",
    days: "30 Days",
    highlight: true,
    tag: "MOST PROFITABLE",
    tagline: "Grow fast and sign real recurring contracts.",
    footer: "We do all the work",
    features: [
      "Everything in the $197 plan",
      "Up to 50 booked appointments",
      "Built to land 1 or 2 paying contracts",
      "We build your website for you",
      "Set up your customer tracking system",
      "Email & text follow-ups done for you",
      "Get found on Google, grow your reviews",
      "Every single piece done for you",
    ],
    ctaLabel: "Build My Business",
  },
  {
    id: "growth-engine",
    badge: "MOST CHOSEN",
    name: "Growth Engine Pipeline™",
    price: "$197",
    priceNote: "one-time",
    days: "14 Days",
    highlight: false,
    tag: null,
    tagline: "Build a steady flow of commercial jobs.",
    footer: "Your city, yours only",
    features: [
      "Everything in the $47 plan",
      "Up to 25 booked appointments",
      "Fix your offer so more people say yes",
      "Set the right prices to win more jobs",
      "Auto follow-ups when leads go quiet",
      "Improve how you close on the phone",
      "We run the whole thing for you",
    ],
    ctaLabel: "Grow My Pipeline",
  },
];

export default function WebsitePricing() {
  const [selectedPkg, setSelectedPkg] = useState(null);
  const [submitting, setSubmitting]   = useState(false);
  const [submitted, setSubmitted]     = useState(false);
  const [form, setForm] = useState({
    name: "", phone: "", email: "", company: "", website: "", note: "",
  });

  const openModal = (pkg) => {
    setSelectedPkg(pkg);
    setSubmitted(false);
    setForm({ name: "", phone: "", email: "", company: "", website: "", note: "" });
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setSelectedPkg(null);
    setSubmitted(false);
    document.body.style.overflow = "";
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.phone.trim()) {
      alert("Please fill in your name, phone, and email before continuing.");
      return;
    }
    setSubmitting(true);
    try {
      const res = await fetch(`${WORKER_URL}/pricing-form`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...form,
          package: selectedPkg.name,
          packagePrice: selectedPkg.price,
        }),
      });
      const data = await res.json();
      console.log("Worker response:", res.status, data);
      if (!data.success) throw new Error(data.error || "Unknown error");
      
      setSubmitted(true);
    } catch (err) {
      console.error(err);
      alert("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="wp-page">

      {/* ── TOP VIDEO ── */}
<div className="wp-top-vid-wrap">
  <video
    src="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/videos/client%20acquisition%20video.mp4"
    autoPlay
    muted
    loop
    playsInline
    preload="auto"
    className="wp-top-vid"
  />

  <style>{`
    .wp-top-vid-wrap {
      max-width: 900px;
      margin: 0 auto 48px;
      padding: 100px 28px 0;
      box-sizing: border-box;
    }
    .wp-top-vid {
      width: 100%;
      display: block;
      height: auto;
      border-radius: 20px;
      box-shadow: 0 24px 60px rgba(123,25,188,0.18);
    }
    @media (max-width: 720px) {
      .wp-top-vid-wrap {
        padding: 80px 18px 0;
        margin-bottom: 36px;
      }
      .wp-top-vid {
        border-radius: 14px;
      }
    }
  `}</style>
</div>


 {/* ── PRICING ── */}
      <div className="wp-packages-wrap">
        <div className="wp-header">
          <div className="wp-eyebrow">Commercial Client Acquisition — Pilot Program</div>
          <h1 className="wp-headline">Get Paying Commercial Clients In 7–30 Days.</h1>
          <p className="wp-subline">
            We do everything — find leads, book calls, set up your system. You just pick up the phone.
          </p>
          <div className="wp-spot-badge">Only 1 spot per city — first come, first served</div>
        </div>

        <div className="wp-cards">
          {packages.map((pkg) => (
            <div key={pkg.id} className={`wp-card ${pkg.highlight ? "wp-card--hl" : ""}`}>
              {pkg.tag && <div className="wp-card-tag">{pkg.tag}</div>}
              <div className="wp-card-badge">{pkg.badge}</div>

              <div className="wp-card-icon-row">
                <div className="wp-card-icon">
                  {pkg.id === "test-pilot" && (
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M3 15l3.5-7 3.5 3.5 2.5-5" stroke="#7b19bc" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )}
                  {pkg.id === "full-system" && (
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M10 2l2 4.5 4.5.65-3.25 3.15.77 4.5L10 12.5 5.98 14.8l.77-4.5L3.5 7.15 8 6.5z" stroke="#fff" strokeWidth="1.6" strokeLinejoin="round"/>
                    </svg>
                  )}
                  {pkg.id === "growth-engine" && (
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M3 16l4-7 3.5 3 3.5-7" stroke="#7b19bc" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )}
                </div>
                {pkg.days && (
                  <span className="wp-card-days">{pkg.days}</span>
                )}
              </div>

              <h3 className="wp-card-name">{pkg.name}</h3>

              <div className="wp-card-price-row">
                {pkg.originalPrice && <span className="wp-card-original">{pkg.originalPrice}</span>}
                <span className="wp-card-price">{pkg.price}</span>
              </div>
              <div className="wp-card-price-note">{pkg.priceNote}</div>

              <div className="wp-divider" />

              <ul className="wp-card-features">
                {pkg.features.map((f, i) => (
                  <li key={i} className="wp-card-feature">
                    <svg className="wp-check" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M3 8.5l3.5 3.5 6.5-7" stroke={pkg.highlight ? "#fff" : "#7b19bc"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    {f}
                  </li>
                ))}
              </ul>

              <p className="wp-card-tagline">{pkg.tagline}</p>

              <button
                className={`wp-card-cta ${pkg.highlight ? "wp-card-cta--light" : "wp-card-cta--dark"}`}
                onClick={() => openModal(pkg)}
              >
                {pkg.ctaLabel} →
              </button>

              <div className="wp-card-footer">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M6 1l1.2 2.5 2.8.4-2 2 .5 2.8L6 7.5 3.5 8.7 4 5.9 2 3.9l2.8-.4z"
                    stroke={pkg.highlight ? "rgba(255,255,255,0.35)" : "#b09cc5"}
                    strokeWidth="1.1" strokeLinejoin="round"/>
                </svg>
                {pkg.footer}
              </div>
            </div>
          ))}
        </div>
      </div>





      {/* ── FORM MODAL ── */}
      {selectedPkg && (
        <div className="wp-modal-backdrop" onClick={closeModal}>
          <div className="wp-modal" onClick={(e) => e.stopPropagation()}>

            <button className="wp-modal-close" onClick={closeModal} aria-label="Close">✕</button>

            <div className="wp-modal-left">
              <div className="wp-modal-pkg-badge">{selectedPkg.badge}</div>
              <h3 className="wp-modal-pkg-name">{selectedPkg.name}</h3>
              <div className="wp-modal-pkg-price-row">
                {selectedPkg.originalPrice && (
                  <span className="wp-modal-pkg-original">{selectedPkg.originalPrice}</span>
                )}
                <span className="wp-modal-pkg-price">{selectedPkg.price}</span>
              </div>
              <p className="wp-modal-pkg-note">one-time</p>

              <div className="wp-modal-divider" />

              <ul className="wp-modal-features">
                {selectedPkg.features.map((f, i) => (
                  <li key={i} className="wp-modal-feature">
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
                      <path d="M2.5 8l3.5 3.5 6.5-7" stroke="#a855f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    {f}
                  </li>
                ))}
              </ul>

              <p className="wp-modal-tagline">{selectedPkg.tagline}</p>
            </div>

            <div className="wp-modal-right">
              {!submitted ? (
                <>
                  <h2 className="wp-modal-title">Complete Your Booking</h2>
                  <p className="wp-modal-sub">Fill in your details and we'll get everything set up.</p>

                  <form className="wp-form" onSubmit={handleSubmit}>
                    <div className="wp-form-grid">
                      <div className="wp-form-row">
                        <label className="wp-form-label">Full Name *</label>
                        <input type="text" name="name" required className="wp-form-input"
                          placeholder="Your full name" value={form.name} onChange={handleChange} />
                      </div>
                      <div className="wp-form-row">
                        <label className="wp-form-label">Phone *</label>
                        <input type="tel" name="phone" required className="wp-form-input"
                          placeholder="Your phone number" value={form.phone} onChange={handleChange} />
                      </div>
                    </div>

                    <div className="wp-form-grid">
                      <div className="wp-form-row">
                        <label className="wp-form-label">Email *</label>
                        <input type="email" name="email" required className="wp-form-input"
                          placeholder="you@company.com" value={form.email} onChange={handleChange} />
                      </div>
                      <div className="wp-form-row">
                        <label className="wp-form-label">Company Name</label>
                        <input type="text" name="company" className="wp-form-input"
                          placeholder="Your company name" value={form.company} onChange={handleChange} />
                      </div>
                    </div>

                    <div className="wp-form-row">
                      <label className="wp-form-label">Current Website (if any)</label>
                      <input type="text" name="website" className="wp-form-input"
                        placeholder="https://yourwebsite.com" value={form.website} onChange={handleChange} />
                    </div>

                    <div className="wp-form-row">
                      <label className="wp-form-label">Business & Goals</label>
                      <textarea name="note" className="wp-form-textarea" rows={3}
                        placeholder="What kind of jobs do you do? What city? Any goals?"
                        value={form.note} onChange={handleChange} />
                    </div>

                    <button type="submit" className="wp-form-submit" disabled={submitting}>
                      {submitting ? "Submitting..." : "Submit & Proceed to Payment →"}
                    </button>
                  </form>
                </>
              ) : (
                <div className="wp-confirm-panel">
                  <div className="wp-confirm-icon-wrap">
                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
                      <path d="M5 13.5l6 6 10-12" stroke="#16a34a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>

                  <h2 className="wp-confirm-title">Details Received!</h2>
                  <p className="wp-confirm-body">
                    Thanks, <strong>{form.name}</strong>! Your booking for <strong>{selectedPkg.name}</strong> is confirmed. Complete your payment below to get started.
                  </p>

                  <div className="wp-confirm-summary">
                    <div className="wp-confirm-row">
                      <span className="wp-confirm-label">Package</span>
                      <span className="wp-confirm-val">{selectedPkg.name}</span>
                    </div>
                    <div className="wp-confirm-row">
                      <span className="wp-confirm-label">Investment</span>
                      <span className="wp-confirm-val wp-confirm-val--purple">{selectedPkg.price}</span>
                    </div>
                  </div>

                  <a
                    href={PAYMENT_LINKS[selectedPkg.id]}
                    className="wp-pay-btn"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                      <rect x="1" y="4" width="16" height="11" rx="2" stroke="#fff" strokeWidth="1.6"/>
                      <path d="M1 8h16" stroke="#fff" strokeWidth="1.6"/>
                      <rect x="3.5" y="11" width="3" height="1.5" rx="0.5" fill="#fff"/>
                    </svg>
                    Pay {selectedPkg.price} — Secure Checkout →
                  </a>
                  <p className="wp-pay-note">SSL encrypted · Secure payment · 30 seconds</p>
                </div>
              )}
            </div>

          </div>
        </div>
      )}

      <style>{`
  /* ── BASE ── */
  .wp-page {
    background: #ffffff;
    min-height: 100vh;
    font-family: -apple-system, 'SF Pro Text', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
    color: #0a0a0a;
    box-sizing: border-box;
  }

  /* ── PACKAGES WRAP ── */
  .wp-packages-wrap {
    max-width: 1140px;
    margin: 0 auto;
    padding: 88px 28px 110px;
    box-sizing: border-box;
  }

  /* ── HEADER ── */
  .wp-header { text-align: center; margin-bottom: 64px; }

  .wp-eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.22em;
    text-transform: uppercase;
    color: #7b19bc;
    margin-bottom: 22px;
  }
  .wp-eyebrow::before, .wp-eyebrow::after {
    content: '';
    display: block;
    width: 32px;
    height: 1px;
    background: #7b19bc;
    opacity: 0.35;
  }

  .wp-headline {
    font-family: -apple-system, 'SF Pro Display', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
    font-size: 52px;
    font-weight: 800;
    letter-spacing: -0.038em;
    line-height: 1.06;
    color: #0a0a0a;
    margin: 0 auto 18px;
    max-width: 640px;
  }

  .wp-subline {
    font-size: 16.5px;
    color: #666;
    line-height: 1.7;
    max-width: 460px;
    margin: 0 auto 28px;
  }

  .wp-spot-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 9px 20px;
    border: 1px solid rgba(123,25,188,0.25);
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    color: #7b19bc;
    background: rgba(123,25,188,0.05);
    letter-spacing: 0.01em;
  }
  .wp-spot-badge::before {
    content: '';
    width: 7px; height: 7px;
    border-radius: 50%;
    background: #7b19bc;
    box-shadow: 0 0 0 3px rgba(123,25,188,0.2);
    animation: wp-blink 2s infinite;
  }
  @keyframes wp-blink {
    0%, 100% { box-shadow: 0 0 0 3px rgba(123,25,188,0.2); }
    50%       { box-shadow: 0 0 0 6px rgba(123,25,188,0.08); }
  }

  /* ── CARDS ── */
  .wp-cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 22px;
    align-items: start;
  }

  .wp-card {
    position: relative;
    background: #faf9ff;
    border: 1px solid #ede8f5;
    border-radius: 20px;
    padding: 32px 26px 26px;
    display: flex;
    flex-direction: column;
    transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;
  }
  .wp-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 18px 48px rgba(123,25,188,0.1);
    border-color: rgba(123,25,188,0.3);
  }
  .wp-card--hl {
    background: #7b19bc;
    border-color: #9130cc;
    box-shadow: 0 0 0 1px #9130cc, 0 4px 0 #5a0e8f, 0 24px 60px rgba(123,25,188,0.45);
    margin-top: -10px;
    z-index: 1;
  }
  .wp-card--hl:hover {
    transform: translateY(-8px);
    box-shadow: 0 0 0 1px #9130cc, 0 4px 0 #5a0e8f, 0 36px 80px rgba(123,25,188,0.55);
  }

  .wp-card-tag {
    position: absolute;
    top: -13px; left: 50%;
    transform: translateX(-50%);
    background: #fff;
    color: #7b19bc;
    font-size: 9px;
    font-weight: 900;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    padding: 5px 16px;
    border-radius: 4px;
    white-space: nowrap;
    box-shadow: 0 2px 8px rgba(123,25,188,0.2);
  }

  .wp-card-badge {
    font-size: 9.5px;
    font-weight: 800;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: #b09cc5;
    margin-bottom: 18px;
  }
  .wp-card--hl .wp-card-badge { color: rgba(255,255,255,0.55); }

  .wp-card-icon-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
  }
  .wp-card-icon {
    width: 42px;
    height: 42px;
    border-radius: 11px;
    background: rgba(123,25,188,0.08);
    border: 1px solid rgba(123,25,188,0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .wp-card--hl .wp-card-icon {
    background: rgba(255,255,255,0.12);
    border-color: rgba(255,255,255,0.2);
  }
  .wp-card-days {
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #7b19bc;
  }
  .wp-card--hl .wp-card-days { color: #ffffff; }

  .wp-card-name {
    font-family: -apple-system, 'SF Pro Display', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
    font-size: 18.5px; font-weight: 800;
    letter-spacing: -0.022em;
    color: #0a0a0a;
    margin: 0 0 16px; line-height: 1.25;
  }
  .wp-card--hl .wp-card-name { color: #fff; }

  .wp-card-price-row { display: flex; align-items: baseline; gap: 8px; margin-bottom: 3px; }
  .wp-card-original { font-size: 16px; color: #ccc; text-decoration: line-through; font-weight: 500; }
  .wp-card--hl .wp-card-original { color: rgba(255,255,255,0.35); }

  .wp-card-price {
    font-family: -apple-system, 'SF Pro Display', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
    font-size: 46px; font-weight: 800;
    letter-spacing: -0.045em;
    color: #0a0a0a; line-height: 1;
  }
  .wp-card--hl .wp-card-price { color: #fff; }

  .wp-card-price-note {
    font-size: 11px; color: #bbb;
    letter-spacing: 0.08em; text-transform: uppercase;
    margin-bottom: 22px;
  }
  .wp-card--hl .wp-card-price-note { color: rgba(255,255,255,0.4); }

  .wp-divider { height: 1px; background: rgba(123,25,188,0.1); margin-bottom: 20px; }
  .wp-card--hl .wp-divider { background: rgba(255,255,255,0.15); }

  .wp-card-features {
    list-style: none; padding: 0;
    margin: 0 0 22px;
    display: flex; flex-direction: column; gap: 10px;
    flex: 1;
  }
  .wp-card-feature {
    display: flex; align-items: flex-start; gap: 9px;
    font-size: 13.5px; color: #3a3a3a; line-height: 1.45;
  }
  .wp-card--hl .wp-card-feature { color: rgba(255,255,255,0.82); }
  .wp-check { flex-shrink: 0; margin-top: 1px; }

  .wp-card-tagline {
    font-size: 12.5px; font-style: italic;
    color: #a090b8; margin: 0 0 20px; line-height: 1.5;
  }
  .wp-card--hl .wp-card-tagline { color: rgba(255,255,255,0.5); }

  .wp-card-cta {
    width: 100%; padding: 13px 18px;
    font-family: -apple-system, 'SF Pro Display', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
    font-size: 14px; font-weight: 700;
    border: none; border-radius: 10px;
    cursor: pointer;
    transition: all 0.22s ease;
    margin-bottom: 16px; letter-spacing: -0.01em;
  }
  .wp-card-cta--dark { background: #7b19bc; color: #fff; }
  .wp-card-cta--dark:hover {
    background: #8e20d8;
    transform: translateY(-2px);
    box-shadow: 0 8px 22px rgba(123,25,188,0.35);
  }
  .wp-card-cta--light { background: #fff; color: #7b19bc; }
  .wp-card-cta--light:hover {
    background: #f5edff;
    transform: translateY(-2px);
    box-shadow: 0 8px 22px rgba(0,0,0,0.15);
  }

  .wp-card-footer {
    display: flex; align-items: center; gap: 6px;
    font-size: 11.5px; color: #b09cc5; font-weight: 500;
  }
  .wp-card--hl .wp-card-footer { color: rgba(255,255,255,0.4); }

  .wp-modal-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.55);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 20px;
    box-sizing: border-box;
    animation: wp-fade-in 0.2s ease both;
  }
  @keyframes wp-fade-in {
    from { opacity: 0; }
    to   { opacity: 1; }
  }

  .wp-modal {
    position: relative;
    display: flex;
    width: 100%;
    max-width: 900px;
    max-height: 92vh;
    background: #fff;
    border-radius: 22px;
    overflow: hidden;
    box-shadow: 0 32px 100px rgba(0,0,0,0.3);
    animation: wp-scale-in 0.25s cubic-bezier(0.34,1.56,0.64,1) both;
  }
  @keyframes wp-scale-in {
    from { opacity: 0; transform: scale(0.93); }
    to   { opacity: 1; transform: scale(1); }
  }

  .wp-modal-close {
    position: absolute;
    top: 16px; right: 16px;
    width: 34px; height: 34px;
    border-radius: 50%;
    background: rgba(0,0,0,0.07);
    border: none;
    font-size: 14px;
    color: #555;
    cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    z-index: 10;
    transition: background 0.2s ease, color 0.2s ease;
  }
  .wp-modal-close:hover { background: rgba(0,0,0,0.14); color: #000; }
  .wp-soldout-box {
    position: relative;
    background: #fff;
    border-radius: 18px;
    padding: 40px 32px;
    max-width: 380px;
    width: 100%;
    text-align: center;
    box-shadow: 0 32px 100px rgba(0,0,0,0.3);
    animation: wp-scale-in 0.25s cubic-bezier(0.34,1.56,0.64,1) both;
  }
  .wp-soldout-icon { font-size: 36px; margin-bottom: 14px; }
  .wp-soldout-title {
    font-family: -apple-system, 'SF Pro Display', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
    font-size: 22px; font-weight: 800;
    letter-spacing: -0.02em;
    color: #0a0a0a; margin: 0 0 12px;
  }
  .wp-soldout-body {
    font-size: 14.5px; color: #666;
    line-height: 1.6; margin: 0;
  }

  .wp-modal-left {
    width: 300px;
    flex-shrink: 0;
    background: #7b19bc;
    padding: 44px 32px 36px;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
  }

  .wp-modal-pkg-badge {
    font-size: 9px;
    font-weight: 900;
    letter-spacing: 0.22em;
    text-transform: uppercase;
    color: rgba(255,255,255,0.55);
    margin-bottom: 14px;
  }

  .wp-modal-pkg-name {
    font-family: -apple-system, 'SF Pro Display', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
    font-size: 22px;
    font-weight: 800;
    letter-spacing: -0.025em;
    color: #fff;
    margin: 0 0 16px;
    line-height: 1.2;
  }

  .wp-modal-pkg-price-row {
    display: flex; align-items: baseline; gap: 8px; margin-bottom: 4px;
  }
  .wp-modal-pkg-original {
    font-size: 16px; color: rgba(255,255,255,0.35);
    text-decoration: line-through; font-weight: 500;
  }
  .wp-modal-pkg-price {
    font-family: -apple-system, 'SF Pro Display', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
    font-size: 52px; font-weight: 800;
    letter-spacing: -0.05em;
    color: #fff; line-height: 1;
  }
  .wp-modal-pkg-note {
    font-size: 11px; color: rgba(255,255,255,0.4);
    letter-spacing: 0.1em; text-transform: uppercase;
    margin: 0 0 24px;
  }

  .wp-modal-divider {
    height: 1px;
    background: rgba(255,255,255,0.15);
    margin-bottom: 22px;
  }

  .wp-modal-features {
    list-style: none; padding: 0; margin: 0 0 20px;
    display: flex; flex-direction: column; gap: 11px;
    flex: 1;
  }
  .wp-modal-feature {
    display: flex; align-items: flex-start; gap: 10px;
    font-size: 13px; color: rgba(255,255,255,0.82); line-height: 1.45;
  }
  .wp-modal-feature svg { flex-shrink: 0; margin-top: 1px; }

  .wp-modal-tagline {
    font-size: 12px; font-style: italic;
    color: rgba(255,255,255,0.45); line-height: 1.5;
    margin: 0;
  }

  .wp-modal-right {
    flex: 1;
    padding: 44px 40px 36px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }

  .wp-modal-title {
    font-family: -apple-system, 'SF Pro Display', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
    font-size: 26px; font-weight: 800;
    letter-spacing: -0.025em;
    color: #0a0a0a; margin: 0 0 8px;
  }
  .wp-modal-sub {
    font-size: 14px; color: #777;
    margin: 0 0 28px; line-height: 1.6;
  }

  .wp-form { display: flex; flex-direction: column; gap: 14px; }
  .wp-form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
  .wp-form-row { display: flex; flex-direction: column; gap: 5px; }

  .wp-form-label {
    font-size: 10px; font-weight: 800;
    letter-spacing: 0.14em; text-transform: uppercase;
    color: #b09cc5;
  }

  .wp-form-input,
  .wp-form-textarea {
    background: #faf9ff;
    border: 1px solid #ded7ee;
    border-radius: 9px;
    padding: 10px 12px;
    font-size: 14px; color: #0a0a0a;
    font-family: inherit; outline: none;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
    box-sizing: border-box; width: 100%;
  }
  .wp-form-input::placeholder,
  .wp-form-textarea::placeholder { color: #c8c0d8; }
  .wp-form-input:focus,
  .wp-form-textarea:focus {
    border-color: #7b19bc;
    box-shadow: 0 0 0 3px rgba(123,25,188,0.1);
    background: #fff;
  }
  .wp-form-textarea { resize: vertical; }

  .wp-form-submit {
    margin-top: 4px;
    padding: 14px 24px;
    background: #7b19bc; color: #fff;
    font-family: -apple-system, 'SF Pro Display', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
    font-size: 15px; font-weight: 700;
    border: none; border-radius: 10px;
    cursor: pointer;
    transition: all 0.22s ease;
    box-shadow: 0 4px 0 #5a0e8f;
  }
  .wp-form-submit:hover {
    background: #8e20d8;
    transform: translateY(-2px);
    box-shadow: 0 6px 0 #5a0e8f, 0 12px 28px rgba(123,25,188,0.35);
  }
  .wp-form-submit:active { transform: translateY(0); box-shadow: 0 2px 0 #5a0e8f; }
  .wp-form-submit:disabled { opacity: 0.55; cursor: not-allowed; transform: none; box-shadow: none; }

  .wp-confirm-panel {
    display: flex; flex-direction: column;
    align-items: center; justify-content: center;
    text-align: center;
    flex: 1;
    padding: 20px 0;
    animation: wp-slide-in 0.35s ease both;
  }
  @keyframes wp-slide-in {
    from { opacity: 0; transform: translateY(12px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  .wp-confirm-icon-wrap {
    width: 64px; height: 64px;
    border-radius: 50%;
    background: #dcfce7;
    border: 2px solid #bbf7d0;
    display: flex; align-items: center; justify-content: center;
    margin-bottom: 20px;
  }

  .wp-confirm-title {
    font-family: -apple-system, 'SF Pro Display', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
    font-size: 26px; font-weight: 800;
    letter-spacing: -0.025em;
    color: #0a0a0a; margin: 0 0 12px;
  }

  .wp-confirm-body {
    font-size: 15px; color: #555;
    line-height: 1.7; margin: 0 0 28px;
    max-width: 360px;
  }

  .wp-confirm-summary {
    width: 100%;
    border: 1px solid #ede8f5;
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 28px;
    text-align: left;
  }
  .wp-confirm-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 18px;
    border-bottom: 1px solid #ede8f5;
  }
  .wp-confirm-row:last-child { border-bottom: none; }
  .wp-confirm-label {
    font-size: 11px; font-weight: 700;
    letter-spacing: 0.1em; text-transform: uppercase;
    color: #bbb;
  }
  .wp-confirm-val { font-size: 14px; font-weight: 700; color: #0a0a0a; }
  .wp-confirm-val--purple { color: #7b19bc; }

  .wp-pay-btn {
    display: inline-flex;
    align-items: center; justify-content: center;
    gap: 10px;
    width: 100%;
    padding: 16px 24px;
    background: #7b19bc; color: #fff;
    font-family: -apple-system, 'SF Pro Display', BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
    font-size: 16px; font-weight: 700;
    border-radius: 12px;
    text-decoration: none;
    letter-spacing: -0.01em;
    transition: all 0.22s ease;
    box-shadow: 0 4px 0 #5a0e8f, 0 8px 28px rgba(123,25,188,0.35);
  }
  .wp-pay-btn:hover {
    background: #8e20d8;
    transform: translateY(-3px);
    box-shadow: 0 6px 0 #5a0e8f, 0 16px 40px rgba(123,25,188,0.45);
  }
  .wp-pay-btn:active { transform: translateY(0); box-shadow: 0 2px 0 #5a0e8f; }

  .wp-pay-note {
    margin-top: 10px;
    font-size: 12px; color: #aaa;
    letter-spacing: 0.01em;
  }

  @media (max-width: 980px) {
    .wp-headline { font-size: 38px; }
    .wp-cards { gap: 16px; }
    .wp-card { padding: 26px 20px 22px; }
    .wp-modal { max-width: 700px; }
    .wp-modal-left { width: 260px; padding: 36px 24px 28px; }
    .wp-modal-right { padding: 36px 28px 28px; }
  }

  @media (max-width: 720px) {
    .wp-packages-wrap { padding: 60px 18px 80px; }
    .wp-headline { font-size: 30px; }
    .wp-cards {
      grid-template-columns: 1fr;
      max-width: 420px;
      margin-left: auto; margin-right: auto;
    }
    .wp-card--hl { margin-top: 0; }
    .wp-modal {
      flex-direction: column;
      max-height: 95vh;
    }
    .wp-modal-left {
      width: 100%;
      padding: 28px 24px 20px;
    }
    .wp-modal-pkg-price { font-size: 38px; }
    .wp-modal-features { display: none; }
    .wp-modal-tagline { display: none; }
    .wp-modal-right { padding: 24px 22px 28px; }
    .wp-form-grid { grid-template-columns: 1fr; }
  }

  @media (max-width: 480px) {
    .wp-headline { font-size: 24px; }
    .wp-card-price { font-size: 38px; }
    .wp-modal-backdrop { padding: 12px; }
  }
`}</style>

    </div>
  );
}